import { render, staticRenderFns } from "./task-view-breadcrumbs.vue?vue&type=template&id=b8d002fe&scoped=true&"
import script from "./task-view-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./task-view-breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./task-view-breadcrumbs.vue?vue&type=style&index=0&id=b8d002fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d002fe",
  null
  
)

export default component.exports